import React from 'react';
import {Link, Redirect} from 'react-router-dom'
import Button from '@material-ui/core/Button';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import CircularProgress from '@material-ui/core/CircularProgress';
import {withStyles} from '@material-ui/core/styles';
import ApiFetcher from "../../ApiFetcher";
import Utility from "../../Utility";
import indigo from "@material-ui/core/colors/indigo";

const styles = theme => ({
    root: {
        textAlign: 'center'
    },
    paper: {
        margin: theme.spacing.unit,
    },
    button: {
        margin: 'auto',
        marginTop: theme.spacing.unit,
        marginBottom: theme.spacing.unit,
        width: '80%',
    },
    form: {
        margin: 'auto',
        width: '80%',
    },
    submitHeader: {
        marginTop: theme.spacing.unit * 10,
    },
    errorMessage: {
        color: 'red'
    },
    menu: {
        backgroundColor: indigo[50],
    },
    circularProgress: {
        margin: theme.spacing.unit * 2,
    },
});

function createBackButton(pathname, label, search){
    const ButtonLink = props => <Link to={{pathname: pathname, search: search}} {...props} />;
    return (
        <Button component={ButtonLink} variant="contained" color="primary" fullWidth>{label}</Button>
    )
}

export class SubmitRequestDispatch extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            businessPartnerName: "",
            choicesDispatchNum: [0], // 表示が乱れるのを防ぐため初期値を設定しておく.
            choicesMainCleaningJig: [{name: "主要洗浄冶具"}], // 表示が乱れるのを防ぐため初期値を設定しておく.
            choicesExpendables: [{name: "消耗品関係"}], // 表示が乱れるのを防ぐため初期値を設定しておく.
            dispatchNum: 1,
            dispatchDestination: "",
            mainCleaningJig: "",
            expendables: "",
            note: "",
            pompSpecs: [],
            submitError: [],
            isWaitSearchBusinessPartners: true,
            isWaitGetPompSpecs: true,
            isWaitGetMainCleaningJig: true,
            isWaitGetExpendables: true,
            isWaitSubmitRequestDispatch: false,
        };
        let params = new URLSearchParams(this.props.location.search);
        this.pompSpecId = params.get("pompSpecId");
        this.deliveryStart = params.get("deliveryStart");
        this.deliveryEnd = params.get("deliveryEnd");
        this.businessPartner = params.get("businessPartner");

        this.handleSubmit = this.handleSubmit.bind(this);
        this.onChangeNum = this.onChangeNum.bind(this);
        this.onChangeDispatchDestination = this.onChangeDispatchDestination.bind(this);
        this.onChangeMainCleaningJig = this.onChangeMainCleaningJig.bind(this);
        this.onChangeExpendables = this.onChangeExpendables.bind(this);
        this.onChangeNote = this.onChangeNote.bind(this);
        this.handlePostBusinessPartnersResponse = this.handlePostBusinessPartnersResponse.bind(this);
        this.handleGetSelectItemMainCleaningJigResponse = this.handleGetSelectItemMainCleaningJigResponse.bind(this);
        this.handleGetSelectItemExpendables = this.handleGetSelectItemExpendables.bind(this);
        this.handlePostAddRequestDispatch = this.handlePostAddRequestDispatch.bind(this);
        this.handleGetPompSpecsResponse = this.handleGetPompSpecsResponse.bind(this);

        if(this.isIllegalQueryParam()){
            // 想定されるエラーは以下の通り.
            // 画面が成立しないのでトップ画面に戻す.
            // + トークン期限切れ
            // + クエリーパラメータ(pompSpecId,deliveryStart,deliveryEnd)が不正
            alert('不正なリクエストのためトップ画面に戻ります。');
            this.props.history.push('/');
        }

        if(this.props.onScreen !== undefined){
            this.props.onScreen('配車要求申請画面');
        }
    }

    componentDidMount(){
        if(!this.isIllegalQueryParam()){
            ApiFetcher.postBusinessPartners(this.props.cookies.get('token'), this.pompSpecId, this.deliveryStart, this.deliveryEnd, this.handlePostBusinessPartnersResponse);
            ApiFetcher.getSelectItemPompSpec(this.props.cookies.get('token'), this.handleGetPompSpecsResponse);
            ApiFetcher.getSelectItemMainCleaningJig(this.props.cookies.get('token'), this.handleGetSelectItemMainCleaningJigResponse);
            ApiFetcher.getSelectItemExpendables(this.props.cookies.get('token'), this.handleGetSelectItemExpendables);
        }
    }

    handleGetPompSpecsResponse(responseJson){
        if(Utility.isNullOrUndefined(responseJson.result) || Utility.isNullOrUndefined(responseJson.result.pompSpecs)){
            // 想定されるエラーは以下の通り.
            // 画面が成立しないのでトップ画面に戻す.
            // + トークン期限切れ
            alert('不正なリクエストのためトップ画面に戻ります。');
            this.props.history.push('/');
        }
        else{
            this.setState({isWaitGetPompSpecs: false});
            this.setState({pompSpecs: responseJson.result.pompSpecs});
        }
    }

    handlePostBusinessPartnersResponse(responseJson){
        if(responseJson.message === null || responseJson.message === ""){
            this.setState({isWaitSearchBusinessPartners: false});
            let dispatchableNum = 0;
            let businessPartnerName = "";
            for(let i = 0; i < responseJson.result.businessPartners.length; i++){
                if(responseJson.result.businessPartners[i].objectId === this.businessPartner){
                    dispatchableNum = responseJson.result.businessPartners[i].dispatchableNum;
                    businessPartnerName = responseJson.result.businessPartners[i].name;
                }
            }

            let selectNums = [];
            for(let i = 1; i <= dispatchableNum; i++){
                selectNums.push(i);
            }
            this.setState({choicesDispatchNum: selectNums, businessPartnerName: businessPartnerName});
            this.setState({dispatchNum: selectNums[0]}); // 選択項目の初期値を1つ目の値に設定する.
        }
        else{
            // 想定されるエラーは以下の通り.
            // 画面が成立しないのでトップ画面に戻す.
            // + トークン期限切れ
            // + クエリーパラメータ(pompSpecId,deliveryStart,deliveryEnd)が不正
            alert('不正なリクエストのためトップ画面に戻ります。');
            this.props.history.push('/');
        }
    }

    handleGetSelectItemMainCleaningJigResponse(responseJson){
        if(Utility.isNullOrUndefined(responseJson.result) || Utility.isNullOrUndefined(responseJson.result.mainCleaningJigs)){
            // 想定されるエラーは以下の通り.
            // 画面が成立しないのでトップ画面に戻す.
            // + トークン期限切れ
            alert('不正なリクエストのためトップ画面に戻ります。');
            this.props.history.push('/');
        }
        else{
            this.setState({isWaitGetMainCleaningJig: false});
            this.setState({choicesMainCleaningJig: responseJson.result.mainCleaningJigs});
            this.setState({mainCleaningJig: responseJson.result.mainCleaningJigs[0].name}); // 選択項目の初期値を1つ目の値に設定する.
        }
    }

    handleGetSelectItemExpendables(responseJson){
        if(Utility.isNullOrUndefined(responseJson.result) || Utility.isNullOrUndefined(responseJson.result.expendables)){
            // 想定されるエラーは以下の通り.
            // 画面が成立しないのでトップ画面に戻す.
            // + トークン期限切れ
            alert('不正なリクエストのためトップ画面に戻ります。');
            this.props.history.push('/');
        }
        else{
            this.setState({isWaitGetExpendables: false});
            this.setState({choicesExpendables: responseJson.result.expendables});
            this.setState({expendables: responseJson.result.expendables[0].name}); // 選択項目の初期値を1つ目の値に設定する.
        }
    }

    handleSubmit(){
        this.setState({isWaitSubmitRequestDispatch: true}, () => {
            ApiFetcher.postAddRequestDispatch(
                this.props.cookies.get('token'),
                this.businessPartner,
                this.props.cookies.get('id'),
                this.deliveryStart,
                this.deliveryEnd,
                this.pompSpecId,
                this.state.dispatchNum,
                this.state.dispatchDestination,
                this.state.mainCleaningJig,
                this.state.expendables,
                this.state.note,
                this.handlePostAddRequestDispatch
            );
        });
    }

    handlePostAddRequestDispatch(responseJson){
        this.setState({isWaitSubmitRequestDispatch: false});
        if(responseJson.message === null || responseJson.message === ""){
            alert('配車要求を申請しました。');
            this.props.history.push(this.props.nextPath); // ページ遷移.
        }
        else{
            this.setState({submitError: responseJson.message});
        }
    }

    onChangeNum(event){
        this.setState({dispatchNum: event.target.value});
    }

    onChangeDispatchDestination(event){
        this.setState({dispatchDestination: event.target.value});
    }

    onChangeMainCleaningJig(event){
        this.setState({mainCleaningJig: event.target.value});
    }

    onChangeExpendables(event){
        this.setState({expendables: event.target.value});
    }

    onChangeNote(event){
        this.setState({note: event.target.value});
    }

    isIllegalQueryParam(){
        if(this.pompSpecId === '' || this.pompSpecId === null || this.deliveryStart === null || this.deliveryEnd === null
            || !Utility.isDate(this.deliveryStart) || !Utility.isDate(this.deliveryEnd) || this.businessPartner === '' || this.businessPartner === null){
            return true;
        }
        return false;
    }

    static convertErrorMessagePropertyName(propertyName){
        if(propertyName === 'sellerAccountId'){
            return '協力会社ID:';
        }
        else if(propertyName === 'buyerAccountId'){
            return 'KECID:';
        }
        else if(propertyName === 'expectedUseStartDate'){
            return '配車開始日:';
        }
        else if(propertyName === 'expectedReturnDate'){
            return '配車終了日:';
        }
        else if(propertyName === 'pompSpecId'){
            return 'ポンプ仕様ID:';
        }
        else if(propertyName === 'dispatchNum'){
            return '台数:';
        }
        else if(propertyName === 'dispatchDestination'){
            return '配車先:';
        }
        else if(propertyName === 'mainCleaningJig'){
            return '主要洗浄冶具:';
        }
        else if(propertyName === 'expendables'){
            return '消耗品関係:';
        }
        else if(propertyName === 'note'){
            return '備考:';
        }
        else{
            return '';
        }
    }

    render(){
        // KECアカウントでない場合はアクセス不可のためトップ画面へリダイレクト.
        if(!Utility.isKecRole(this.props.cookies.get('role'))){
            return <Redirect to={{pathname: '/'}}/>;
        }

        // API応答待ち表示.
        if(this.state.isWaitSearchBusinessPartners || this.state.isWaitGetPompSpecs || this.state.isWaitGetMainCleaningJig || this.state.isWaitGetExpendables){
            return (
                <div className={this.props.classes.root}>
                    <CircularProgress className={this.props.classes.circularProgress}/>
                </div>
            );
        }

        return (
            <div className={this.props.classes.root}>
                <div>
                    <h3 className={this.props.classes.menu}>配車情報</h3>
                </div>
                <div>
                    <Paper className={this.props.classes.paper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell align="left">項目</TableCell>
                                    <TableCell align="left">値</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    <TableCell align="left">ポンプ仕様</TableCell>
                                    <TableCell align="left">{Utility.getPompSpecNameFromId(this.state.pompSpecs, this.pompSpecId)}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell align="left">配車期間</TableCell>
                                    <TableCell align="left">{
                                        Utility.formatDate(new Date(this.deliveryStart), 'yyyy/MM/dd')
                                        + "～"
                                        + Utility.formatDate(new Date(this.deliveryEnd), 'yyyy/MM/dd')
                                    }</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell align="left">協力会社名</TableCell>
                                    <TableCell align="left">{this.state.businessPartnerName}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </Paper>
                </div>
                <div className={this.props.classes.submitHeader}>
                    <h3 className={this.props.classes.menu}>申請内容</h3>
                </div>
                <div>
                    {this.state.submitError.map((row, i) =>{
                        return (
                            <div key={i} className={this.props.classes.errorMessage}>
                                {SubmitRequestDispatch.convertErrorMessagePropertyName(row.propertyName)}{row.errorMessage}
                            </div>
                        )
                    })}
                </div>
                <div>
                    <form className={this.props.classes.form}>
                        <div>
                            <TextField
                                select
                                label="台数"
                                selected={this.state.dispatchNum}
                                onChange={this.onChangeNum}
                                SelectProps={{
                                    native: true,
                                }}
                                margin="normal"
                                variant="outlined"
                                fullWidth
                            >
                                {this.state.choicesDispatchNum.map((option, i) => (
                                    <option key={i} value={option}>{option}</option>
                                ))}
                            </TextField>
                        </div>
                        <div>
                            <TextField
                                label="配車先"
                                type="text"
                                margin="normal"
                                variant="outlined"
                                value={this.state.dispatchDestination}
                                onChange={this.onChangeDispatchDestination}
                                fullWidth
                            />
                        </div>
                        <div>
                            <TextField
                                select
                                label="主要洗浄冶具"
                                selected={this.state.mainCleaningJig}
                                onChange={this.onChangeMainCleaningJig}
                                SelectProps={{
                                    native: true,
                                }}
                                margin="normal"
                                variant="outlined"
                                fullWidth
                            >
                                {this.state.choicesMainCleaningJig.map((option, i) => (
                                    <option key={i} value={option.name}>{option.name}</option>
                                ))}
                            </TextField>
                        </div>
                        <div>
                            <TextField
                                select
                                label="消耗品関係"
                                selected={this.state.expendables}
                                onChange={this.onChangeExpendables}
                                SelectProps={{
                                    native: true,
                                }}
                                margin="normal"
                                variant="outlined"
                                fullWidth
                            >
                                {this.state.choicesExpendables.map((option, i) => (
                                    <option key={i} value={option.name}>{option.name}</option>
                                ))}
                            </TextField>
                        </div>
                        <div>
                            <TextField
                                label="備考"
                                type="text"
                                margin="normal"
                                variant="outlined"
                                value={this.state.note}
                                onChange={this.onChangeNote}
                                fullWidth
                            />
                        </div>
                    </form>
                </div>
                <div className={this.props.classes.button}>
                    {
                        this.state.isWaitSubmitRequestDispatch === true &&
                        <CircularProgress className={this.props.classes.circularProgress}/>
                    }
                    {
                        this.state.isWaitSubmitRequestDispatch === false &&
                        <Button variant="contained" color="primary" onClick={this.handleSubmit} fullWidth>申請</Button>
                    }
                </div>
                <div className={this.props.classes.button}>
                    {createBackButton(this.props.backPath, '協力会社選択画面へ戻る', '?pompSpecId=' + this.pompSpecId + '&deliveryStart=' + this.deliveryStart + '&deliveryEnd=' + this.deliveryEnd)}
                </div>
                <div className={this.props.classes.button}>
                    {createBackButton('/', 'トップ画面へ戻る', null)}
                </div>
            </div>
        );
    }
}

export default withStyles(styles)(SubmitRequestDispatch);
